import React from "react";

export const PageHeader = ({ title, subtitle, action }) => (
    <div className="mb-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
            <h1 className="text-3xl font-black text-slate-900">{title}</h1>
            {subtitle && <p className="text-slate-600 mt-2">{subtitle}</p>}
        </div>
        {action}
    </div>
);

export const Panel = ({ title, subtitle, children }) => (
    <div className="bg-white rounded-2xl shadow border border-slate-200 p-6">
        {title && <h2 className="text-2xl font-bold">{title}</h2>}
        {subtitle && <p className="text-slate-500 mt-1 mb-5">{subtitle}</p>}
        {children}
    </div>
);

export const KpiCard = ({ title, value, color = "blue" }) => {
    const colors = {
        blue: "bg-blue-50 text-blue-700",
        green: "bg-green-50 text-green-700",
        red: "bg-red-50 text-red-700",
        yellow: "bg-yellow-50 text-yellow-700",
        purple: "bg-purple-50 text-purple-700",
        indigo: "bg-indigo-50 text-indigo-700",
        teal: "bg-teal-50 text-teal-700",
        slate: "bg-slate-50 text-slate-700",
        orange: "bg-orange-50 text-orange-700",
    };

    return (
        <div className="bg-white rounded-2xl shadow border border-slate-200 p-6 hover:shadow-xl transition">
            <p className="text-slate-500">{title}</p>
            <div className={`inline-flex mt-3 px-3 py-1 rounded-xl font-black text-3xl ${colors[color] || colors.blue}`}>
                {value ?? "�"}
            </div>
        </div>
    );
};

export const InfoRow = ({ label, value }) => (
    <div className="bg-slate-50 rounded-xl p-3 border border-slate-200">
        <p className="text-xs uppercase tracking-wide text-slate-500 font-semibold">
            {label}
        </p>
        <p className="font-bold text-slate-900 mt-1 break-words">
            {value ?? "�"}
        </p>
    </div>
);

export const StatusBadge = ({ active, activeText = "Online", inactiveText = "Offline" }) => (
    <span
        className={`inline-flex rounded-full px-3 py-1 text-xs font-bold ${active ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
            }`}
    >
        {active ? `? ${activeText}` : `? ${inactiveText}`}
    </span>
);

export const PrimaryButton = ({ children, ...props }) => (
    <button
        {...props}
        className={`rounded-xl bg-blue-600 px-5 py-3 text-white font-semibold hover:bg-blue-700 transition disabled:opacity-60 ${props.className || ""}`}
    >
        {children}
    </button>
);
export const SuccessButton = ({ children, ...props }) => (
    <button
        {...props}
        className={`rounded-xl bg-green-600 px-5 py-3 text-white font-semibold hover:bg-green-700 transition disabled:opacity-60 ${props.className || ""}`}
    >
        {children}
    </button>
);
export const DarkButton = ({ children, ...props }) => (
    <button
        {...props}
        className={`rounded-xl bg-slate-800 px-5 py-3 text-white font-semibold hover:bg-slate-900 transition disabled:opacity-60 ${props.className || ""}`}
    >
        {children}
    </button>
);

export const EmptyText = ({ text }) => (
    <p className="text-slate-500">{text}</p>
);